<template>
    <div ref="editTbl">
        <h4 class="pl-3 pt-3">
          {{tab.table?'Edit':'Create'}} table          
        </h4>
        <div class="">
            <div>
                <p class="pl-3">Table name:</p>
                <v-text-field
                    outlined
                    dence
                    v-model="nameTbl"
                    :rules="[rulesName.required]"
                    class="txtName px-3"
                    height="38px"
                    ></v-text-field>
                    <!-- ref="txtNameTbl" -->
                    <!-- @focus="onFocus" -->
            </div>
            <!-- hide-default-footer -->
            <v-data-table
                :headers="headers"
                :items="items"
                hide-default-header
                single-select
            >
                <template
                    v-slot:header="{ props: { headers } }"
                >
                    <thead>
                        <tr>
                            <th v-for="item,ix in headers" :class="classBorderHdr(ix,item)">
                                {{item['text']}}
                            </th>
                        </tr>
                    </thead>
                </template>
                <template
                    v-slot:body="{ items }"
                >
                    <tbody>
                    <tr
                        v-for="item,ix in items"
                    >
                        <td class="borderCell nameCell d-flex" >
                            <v-text-field
                                :rules="[rulesName.required]"
                                variant='solo-filled'
                                dence
                                hide-details
                                class="txtFld flex-shrink-1"
                                v-model="items[ix].name"
                            ></v-text-field>
                        </td>
                        <td class="borderCell cellType">
                            <v-combobox
                                dense
                                :items="typesArr"
                                hide-details
                                v-model="items[ix].type"
                                @focus="focusCombo($event)"
                                @blur="blurCombo($event)"
                            />
                        </td>
                        <td class="borderCell checkBoxCell" :class="checkPk(ix) ? 'cellDisable' : ''">
                            <v-checkbox
                                v-model="items[ix].pk"  
                                hide-details
                                color="#4083ff"
                                :disabled = checkPk(ix)
                                @click=""                        
                            ></v-checkbox>
                        </td>
                        <td class="borderCell checkBoxCell" :class="checkFk(ix) ? 'cellDisable' : ''">
                            <v-checkbox
                                v-model="items[ix].fk"  
                                hide-details
                                color="#4083ff" 
                                :disabled = checkFk(ix)                            
                            ></v-checkbox>
                        </td>
                        <td class="borderCell cellType">
                            <v-combobox
                                dense
                                :items="tabelsArr"
                                hide-details
                                :disabled = checkFKtable(ix)
                                v-model="items[ix].linktable"
                            />
                        </td>
                        <td class="borderCell checkBoxCell indtCell" :class="checkIdnt(ix) ? 'cellDisable' : ''">
                            <v-dialog
                                v-model="items[ix].Identity.show"
                                width="500"
                            >
                                <template v-slot:activator="{ attrs }">
                                    <v-checkbox
                                        v-model="items[ix].Identity.bool"  
                                        hide-details
                                        color="#4083ff"
                                        v-bind="attrs"
                                        :disabled = checkIdnt(ix)
                                        @click.native.capture = changeStatus($event)
                                        @mousedown="showInd(items[ix].Identity)"  
                                        />
                                        <!-- @mouseup="checkBool(items[ix].Identity)"  -->
                                        <!-- @click="showInd(items[ix].Identity)"-->
                                </template>
                                <v-card>
                                    <v-card-title class="text-h5 grey lighten-2">
                                        Identity
                                    </v-card-title>
                                    <v-card-text>
                                        <!-- :rules="rulesName" -->
                                        <p class="mb-2">Increment</p>
                                        <!-- hide-details="true" -->
                                        <v-text-field
                                            outlined
                                            dence
                                            color="#4083ff"
                                            class="txtFld flex-shrink-1"
                                            v-model="items[ix].Identity.increment"
                                            :rules="[rulesIdnt.required, rulesIdnt.lessEqualZero, rulesIdnt.notNumber]"
                                        ></v-text-field>
                                        <p class="mt-4 mb-2">Seed</p>
                                        <!-- hide-details="true" -->
                                        <v-text-field
                                            outlined
                                            dence
                                            class="txtFld flex-shrink-1"
                                            v-model="items[ix].Identity.seed"
                                            :rules="[rulesIdnt.required, rulesIdnt.lessEqualZero, rulesIdnt.notNumber]"
                                            color="#4083ff"
                                        ></v-text-field>
                                    </v-card-text>

                                    <v-divider></v-divider>

                                    <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        color="#4083ff"
                                        text
                                        @click="clickSaveBtn(ix)"
                                        :disabled = checkIdntSave(ix)
                                    >
                                        save
                                    </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </td>
                        <td class="borderCell checkBoxCell">
                            <v-checkbox
                                v-model="items[ix].nullable"  
                                hide-details
                                color="#4083ff"    
                                :disabled = checkPkNull(ix)                                                    
                            ></v-checkbox>
                        </td>
                        <td class="borderCellBtn"> 
                            <v-btn
                                elevation="2"
                                small
                                @click="delRow(ix)"
                            >
                                <v-icon dark>
                                    mdi-minus
                                </v-icon>
                            </v-btn>
                        </td>
                    </tr>
                    </tbody>
                </template>
                <template
                    v-slot:footer
                >
                    <v-btn
                        elevation="2"
                        small
                        @click = "addRow()"
                        class="ml-3 mt-3 mb-3"
                    >
                        <v-icon dark>
                            mdi-plus
                        </v-icon>
                    </v-btn>
                </template>
            </v-data-table>
        </div>
        <div class="d-flex mt-6 pl-3">
            <v-btn
                elevation="2"
                small
                class="mr-3"
                color="#007bff"
                @click="clickSaveTbl()"
                :class="boolCmb"
            >
                <!-- :disabled="boolCombo" -->
               <span class="white--text">save</span>
            </v-btn>
            <v-btn
                elevation="2"
                small
                color="#007bff"
                @click="clickCancel()"
            >
                <span class="white--text">cancel</span>
            </v-btn>
        </div>
    </div>
</template>

<script>
import { commonMixin } from '../common.js';
import LeftMenu from './left-menu.vue';
import leftMenu from './left-menu.vue';

export default  {
    mixins: [commonMixin],
    components: {LeftMenu},
    data () {
      return {
        boolCombo: true,
        nameTbl: null,
        rulesName: {
            required: value => !!value || 'Required' 
        },
        rulesIdnt: {
            required: value => !!value || 'Required.',
            lessEqualZero : value => !(value <= 0) || 'The minimum allowed value for the Seed and Increment fields is "1"',
            notNumber : value => !isNaN(value) || 'not a number',
        },
        headers: [
          {
            text: 'Name',
            align: 'start',
            sortable: false,
            value: 'name',
            width: '160'          
          },
          { text: 'Type', value: 'type', width: '160'},
          { text: 'PK', value: 'pk' },
          { text: 'FK', value: 'fk' },
          { text: 'FK table', value: 'linktable' },
          { text: 'Identity', value: 'Identity' },
          { text: 'NOT NULL', value: 'nullable' },
          { text: '', value: 'btn' },
        ],
        items: [
        ],
        typesArr: [
            'bigint',
            'binary(50)',
            'bit',
            'char(10)',
            'date',
            'datetime',
            'datetime2(7)',
            'decimal(18,0)',
            'double',
            'int',
            'nvarchar(50)',
            'nchar(10)',
            'nvarchar(MAX)',
            'rowversion',
            'varbinary(50)',
            'varbinary(MAX)',
            'varchar(50)',
            'varchar(MAX)'
        ]
      }      
    },
    props: {
        tab:{
            required: true,
            type: Object,
        },
        state:{
            required: true,
            type: Object,
        },
    },
    created(){
        this.getItems()
    },
    mounted() {
        this.clickCancel()
    },
    methods: {
        focusCombo(e) {
            console.log('focusCombo', e);
            this.boolCombo = true
        },
        blurCombo(e) {
            console.log('blurCombo', e);
            this.boolCombo = false
        },
        getItems() {
          if (this.tab.table) {
            this.nameTbl = this.tab.table
            this.items = [];
            let flds = this.tab.db.data.find(el => el.tablename === this.tab.table)
            console.log('comp',flds)

            for (let i = 0; i < flds.fields.length; i++) {
                const e = flds.fields[i];
                // console.log('call typePrecision 1');                
                this.items.push(
                    {
                    type: '' + this.typePrecision(flds.fields[i]),
                    name:e.name,
                    subtype:e.subtype,
                    nullable: e.nullable==0 ? 1 : 0 ,
                    linktable:e.linktable,
                    pk:e.subtype==1,
                    fk:e.subtype==2, 
                    readonly:true,
                    // Identity:e.increment ? true : false,
                    Identity: {
                        bool:e.increment ? true : false,                        
                        increment: e.increment,
                        seed: e.seed,
                        show:false
                    },
                    index: i,
                    // precision: e.precision,
                    // scale: e.scale
                }
                )
            }
        }
        },
        // setFocusSearchbox() {
        //     this.$refs.txtNameTbl.focus();
        // },
        addRow() {
            this.items.push(
                {
                    name: '',
                    type: null,
                    pk: false,
                    fk: false,
                    linktable: '',
                    Identity: {
                        bool: false,
                        increment: '1',
                        seed: '1',
                        show: false
                    },
                    nullable: false,
            })
            console.log('addRow',this.items);
        },
        delRow(ix) {
            if (this.items.length > 0) {
                console.log('delRow',ix);            
                this.items.splice(ix, 1);
            }
        },
        classBorderHdr(ix, item) {
            let classCell = ''
            if (ix < this.headers.length-1) {    
                classCell += 'borderHdr' 
            }
            // if (item.text == 'Type') {    
            //     classCell += 'hdrType' 
            // }
            return classCell
        },
        changeStatus(event) {
            event.stopPropagation()
        },
        showInd(Identity) {
            console.log('showInd');            
            if (Identity.bool) {
                Identity.bool = false
                return
            } else {
                Identity.show = true
            }
            // Identity.seed = 1
            // Identity.increment = 1
            return
        },
        clickSaveBtn(ix) {
            this.items[ix].Identity.show = false
            this.items[ix].Identity.bool = true
            this.items[ix].nullable = true
        },
        checkPkNull(ix) {
            const result = this.items.findIndex((i,ind) => i.pk == true)
            // console.log('checkPkNull ix', result);
            if (result == ix) {
                return true 
            }
            return false
        },
        checkPk(ix) {
            const result = this.items.findIndex((i,ind) => i.pk == true)
            // console.log('checkPk r', result);
            if (result == -1) {
                return false                
            }
            if (result == ix) {
                // console.log('checkPk ix', result);
                if (this.items[ix].pk == true) {
                    this.items[ix].fk = false  
                    this.items[ix].nullable = true                 
                }
                return false                
            }
            return true
        },
        checkFk(ix) {
            const result = this.items.findIndex((i,ind) => i.pk == true)
            // console.log('checkFk r', result);
            // console.log('checkFk ix', ix);
            if (result == -1) {
                return false                
            }
            if (result == ix) {
                return true                
            }
            // return true
        },
        checkIdnt(ix) {            
            if (this.items[ix].type == 'int' || this.items[ix].type == 'bigint') {
                const result = this.items.findIndex((i,ind) => i.Identity.bool == true)
                if (result == -1) {
                    return false                
                }
                if (result == ix) {
                    return false               
                }
            } 
            this.items[ix].Identity.bool = false
            return true
        },
        checkFKtable(ix) {
            // console.log('checkFKtable',ix);
            if (this.items[ix].fk == true) {
                // console.log('checkFKtable 1',ix);
                const result = this.items.findIndex((i,ind) => i.fk== true && ind== ix)            
                // console.log('checkFKtable result',ix, result);
                if (result == ix) {
                    // console.log('checkFKtable 2',ix);
                    return false               
                }
            }
            return true
        },
        checkIdntSave(ix) {
            // console.log(
            //     'checkIdntSave incr',
            //     isNaN(this.items[ix].Identity.increment),
            //     typeof this.items[ix].Identity.increment
            // )
            // console.log(
            //     'checkIdntSave seed',
            //     isNaN(this.items[ix].Identity.seed),
            //     typeof(this.items[ix].Identity.seed),
            // );
            if (
                this.items[ix].Identity.increment <=0 || 
                this.items[ix].Identity.increment == "" ||
                isNaN(this.items[ix].Identity.increment) 
            ) {
                return true 
            }
            if (
                this.items[ix].Identity.seed <=0 || 
                this.items[ix].Identity.seed == "" ||
                isNaN(this.items[ix].Identity.seed)
            ) {
                return true 
            }
            return false
        },
        clickSaveTbl() {
            if(!this.CheckNameIsValid(this.nameTbl)){
                    // console.log('if 5');
                this.ShowAlert('Enter valid table name');
                return;
            }           
            let query = []
            let countRowversion = this.items.filter(i => i.type == 'rowversion')
            if (countRowversion.length > 1) {
                this.ShowAlert('Only one rowversion column is allowed per table');
                return;
            }            
            if (!this.tab.table) {
                console.log('clickSaveTbl 1');                
                query = this.items.map( e => {
                    let cmd = ''
                    if(!this.CheckNameIsValid(e.name)){
                        // console.log('if 5');
                        this.ShowAlert('Enter valid column name');
                        return;
                    }
                    if(!e.type){
                        // console.log('if 6_2');
                        this.ShowAlert('Enter column type');
                        return;
                    }
                    if(e.fk && !e.linktable){
                        console.log('if 6_3');
                        this.ShowAlert('Enter FK table');
                        return;
                    }
                    cmd = '['+e.name+']' + ' ' + e.type +  (e.Identity.bool? ' IDENTITY(' + e.Identity.seed + ',' + e.Identity.increment + ')' : '') + (e.pk?' PRIMARY KEY':'')+ (e.nullable?' NOT NULL':'') + (e.fk?' , FOREIGN KEY('+'['+e.name+']'+') REFERENCES '+ e.linktable:'');
                    return cmd
                })            
                if (query.filter(i => !i).length > 0) {
                    console.log('clickSaveBtn',query.filter(i => !i));
                    return
                }
                // console.log('clickSaveBtn',t);
                this.state.queryNumber++
                this.ExecScript(this.tab.db, `CREATE TABLE [${this.nameTbl}] (${query.join(',')}) `,response=>{
                    if (!response.data[0].err){
                        this.LoadDbFromServer(this.tab.db
                        // (response)=>{
                        //     console.log('LoadDbFromServer if resp',response);
                        //     for (let i = 0; i < response.data.data.length; i++) {
                        //         const t = response.data.data[i];
                        //         if(t.tablename == this.nameTbl){
                        //             this.tab.table = t;
                        //             this.ShowAlert('Saved');
                        //             break;
                        //         }
                        //     }
                        // }                        
                        )
                    } else {
                        this.ShowAlert(`Error: ${response.data[0].msg}`);
                    }
                },true,this.tab.idconnect,this.state.guid)                
            }
            if (this.tab.table) {
                let oldArr = [];
                let flds = this.tab.db.data.find(el => el.tablename === this.tab.table)
                for (let i = 0; i < flds.fields.length; i++) {
                    const e = flds.fields[i];
                    // console.log('call typePrecision 2');
                    oldArr.push({
                        type:''+this.typePrecision(flds.fields[i]),
                        name:e.name,
                        subtype:e.subtype,
                        nullable: e.nullable==0 ? 1 : 0 ,
                        linktable:e.linktable,
                        pk:e.subtype==1,
                        fk:e.subtype==2, 
                        readonly:true,
                        // Identity:e.increment ? true : false,
                        Identity: {
                            bool:e.increment ? true : false,                        
                            increment: e.increment,
                            seed: e.seed,
                            show:false
                        },
                        // precision: e.precision,
                        // scale: e.scale
                    })
                }
                let query = []  
                console.log('clickSaveTbl 2 this.items', this.items.length); 
                this.items.forEach((item,i) => {
                    if(item.index >= 0) {
                        query.push(item.index)      
                    }
                })   
                // console.log('clickSaveTbl 2 old', oldArr);
                // console.log('clickSaveTbl 2 q', query);
                let r=[];
                let strAlter
                let renameQuery = []
                let deleteColumn = []
                let addColumn = []
                let alterColumn = []
                let alterColumnQuery = []
                let numbers = Array.from({length: oldArr.length}, (_, i) => i)
                // console.log('clickSaveTbl 2 numbers', numbers);
                let difference = numbers.filter(x => !query.includes(x)).concat(query.filter(x => !numbers.includes(x)));
                difference.forEach((element,i) => {
                    if (oldArr[element] !== undefined) {
                        deleteColumn.push(oldArr[element].name)
                    }
                });
                // console.log('clickSaveTbl 2 difference', difference);
                if (this.items.length > oldArr.length) {
                    // console.log('addCol1', this.items, oldArr, difference);
                    if (difference.length == 0) {
                        console.log('clickSaveTbl 3 1');
                        // console.log('addCol1_1', this.items.length, oldArr.length, difference.length);
                        this.createCmd(addColumn,this.items.length-1)                        
                    } else if (difference.length == 1) {
                        console.log('clickSaveTbl 3 2');
                        // console.log('addCol1_2', this.items.length, oldArr.length, difference.length);
                        this.createCmd(addColumn,oldArr.length - difference.length)
                    } else {
                        console.log('clickSaveTbl 3 3');
                        // console.log('addCol1_else', this.items.length, oldArr.length, difference.length);
                        this.createCmd(addColumn,this.items.length-1)
                    }               
                    // this.createCmd(addColumn,0)
                };
                if (this.items.length <= oldArr.length) {
                    // console.log('addCol2', difference);                    
                    let bool = difference.find(el => el == oldArr.length-1)
                    if (bool !== undefined) {
                        if ((oldArr.length - difference.length) > 0) {
                            // console.log('addCol2_1', oldArr, difference);
                            this.createCmd(addColumn,oldArr.length - difference.length)
                        } else if ((oldArr.length - difference.length) == 0) {
                            // console.log('addCol2_2', oldArr, difference);
                            this.createCmd(addColumn,0)
                        } else {
                            // console.log('addCol2_else', oldArr, difference);
                            this.createCmd(addColumn,0)
                        }
                    } else {
                        // console.log('addCol2 else', oldArr, difference);
                        this.createCmd(addColumn,oldArr.length - difference.length)
                    }
                }
                if (query.length > 0) {
                    query.forEach((el) => {
                        let newName = this.items.find(it => it.index === el)                        
                        if (newName.name != oldArr[el].name) {
                            renameQuery.push(`${oldArr[el].name} ${newName.name}`)
                        }
                    })
                    for (let i = 0; i < query.length; i++) {
                        let ind = query[i]
                        let newVal = this.items.find(el => el.index === ind)
                        console.log('clickSaveTbl newVal',newVal);
                        if(newVal.fk && newVal.linktable === ''){
                            this.ShowAlert('Enter FK table');
                            return;
                        }
                        for(let key in newVal){
                            if (key == 'type') {
                                let val = newVal.type.replace(/[ \t]/g, '')
                                // let valOld = this.typePrecision(oldArr[ind]).replace(/[ \t]/g, '')
                                let valOld = oldArr[ind].type.replace(/[ \t]/g, '')
                                // console.log('type',val,valOld);
                                if (val != valOld) {
                                    alterColumn[ind] = newVal
                                    console.log('clickSaveTbl alterColumn type 1',alterColumn); 
                                    break
                                }
                            }
                            if (key == 'Identity') {
                                let val = newVal.Identity
                                let valOld = oldArr[ind].Identity
                                // console.log('Identity',JSON.stringify(val),JSON.stringify(valOld));
                                if (JSON.stringify(val) !== JSON.stringify(valOld)) {
                                    console.log('clickSaveTbl alterColumn Identity 1',alterColumn);
                                    alterColumn[ind] = newVal
                                } 
                            }
                            if( key !== 'name' && key != 'type' && key !== 'index' && key !== 'Identity' && newVal[key] !== oldArr[ind][key]) {
                                console.log('clickSaveTbl 2 key alterColumn',newVal[key]);
                                console.log('clickSaveTbl 2 key alterColumn',oldArr[ind][key]);
                                alterColumn[ind] = newVal
                                break
                            }
                        }
                    }
                                          
                    alterColumn.forEach((element,i) => {
                        if (!this.isEmpty(element)) {
                            const e = element;
                            console.log('clickSaveTbl alterColumnQuery el',e, e.type);
                            let cmd = oldArr[i].name + ' ' + e.type + (e.Identity.bool? ' IDENTITY(' + e.Identity.seed + ',' + e.Identity.increment + ')' : '') + (e.pk?' PRIMARY KEY':'') + (e.nullable?' NOT NULL':'') +  (e.fk?' FOREIGN KEY('+'['+oldArr[i].name+']'+') REFERENCES '+ e.linktable:'');
                            alterColumnQuery.push(cmd)
                        }
                    })
                }
                if (addColumn.length >0 || alterColumnQuery.length >0 || deleteColumn.length >0 || renameQuery.length >0) strAlter = 'ALTER TABLE ' + this.nameTbl
                if (deleteColumn.length >0) r.push('DROP COLUMN ' + deleteColumn.join(', '))
                if (addColumn.length >0) r.push('ADD COLUMN ' + addColumn.join(', '))
                if (alterColumnQuery.length >0) r.push('ALTER COLUMN ' + alterColumnQuery.join(', '))
                if (renameQuery.length >0) r.push('RENAME ' + renameQuery.join(', '))
                console.log('clickSaveTbl r',strAlter,r.join(', '));
                addColumn = []
                alterColumnQuery = []
                deleteColumn = []
                renameQuery = []                
                oldArr = [];
                query = []
                this.ExecScript(this.tab.db, strAlter + ' ' + r.join(', '),response=>{
                    if (!response.data[0].err){
                        this.ShowAlert('Saved');
                        this.LoadDbFromServer(this.tab.db 
                        // (response)=>{
                        //     for (let i = 0; i < response.data.data.length; i++) {
                        //         const t = response.data.data[i];
                        //         if(t.tablename == this.nameTbl){
                        //             console.log('ExecScript if resp',t.tablename, this.nameTbl);
                        //             this.tab.table = t;
                        //             break;
                        //         }
                        //     }
                            
                        //     console.log('LoadDbFromServer resp',this.$refs);
                        //     // this.$refs.leftMenu.getArr()
                        // }
                        )
                    } else {
                        this.ShowAlert(`Error: ${response.data[0].msg}`);
                    }
                },true,this.tab.idconnect,this.state.guid)
                strAlter = null  
            }
        },
        clickCancel() {
            if (!this.tab.table) {
                this.items = [
                    {
                        name: '',
                        type: null,
                        pk: false,
                        fk: false,
                        linktable: '',
                        Identity: {
                            bool: false,
                            increment: '1',
                            seed: '1',
                            show: false
                        },
                        nullable: false
                    }
                ]                
            }
            this.getItems()
        },
        typePrecision(fld) {  
            let val = ''
            // console.log('typePre type subtype',fld.type, fld.subtype);
            let type = this.typemap[fld.type+'-'+fld.subtype]
            
            if (fld.precision != 0 && fld.precision != -1) {
                switch (+fld.type) {
                case 12:
                    val = ` (${fld.precision},${fld.scale}) `
                    break;
                    
                case 5:
                    if(fld.precision == 7) {
                        type = 'datetime'
                        val = ` (${fld.precision}) `
                    } else if((fld.precision == 3)) {
                        type = 'datetime'
                        val = ``
                    }
                    break;

                default:
                    val = ` (${fld.precision}) `
                    break;
                }      
            } else if (fld.precision == -1) {
                val =` (max) `
            }
            let str =  type + val
            // console.log('typePre str',str);
            return str
        },
        createCmd(arr,ind) {
            for (let i = ind; i < this.items.length; i++) {
                console.log('createCmd', this.items[i]);            
                const e = this.items[i];
                let cmd = '['+e.name+']' + ' ' + e.type + (e.Identity.bool? ' IDENTITY(' + e.Identity.seed + ',' + e.Identity.increment + ')' : '') + (e.pk?' PRIMARY KEY':'')+ (e.nullable?' NOT NULL':'') + (e.fk?' FOREIGN KEY('+'['+e.name+']'+') REFERENCES '+ e.linktable:'');
                arr.push(cmd);
            }
        },
        isEmpty(obj) {
            // console.log('isEmpty',obj);
            for (const prop in obj) {
                if (Object.hasOwn(obj, prop)) {
                    return false;
                }
            }
            return true;
        }
    },
    computed: {
        tabelsArr() {
            const arr = this.tab.db.data.map(i => {
                let bool = i.fields.find(it => it.subtype == 1)
                // console.log('tabelsArr', bool);                
                if (bool && bool.subtype == 1) {
                   return i.tablename
                }
            })
            // console.log('tabelsArr', arr);
            return arr
        },
        boolCmb() {

            let bool = 'el'
            return bool
        }
    }
}
</script>

<style lang="scss">
.cellDisable {
    opacity: .6;
    cursor: default;
    pointer-events: none;
}
.indtCell {
    input {
        display: none;
    }
}
.borderHdr {
    border-right: 1px solid #ddd;
    border-top: 1px solid #ddd;
}
.borderCellBtn {
    border-bottom: 1px solid #ddd;
    height: 48.5px !important;
}
.borderCell {
    border-right: 1px solid #ddd;
    border-bottom: 1px solid #ddd;
    height: 48.5px !important;
}
.borderCell:hover {
    background: #eee;
}
.theme--light.v-data-table > .v-data-table__wrapper > table > tbody > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: none;
}
.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: inherit;
    border-style: none;
    border-width: thin 0 0 0;
}
.nameCell{
    .v-text-field {
        .v-input__control {
            .v-input__slot:after {
                background-color: none;
                border-color: none;
                border-style: none;
                border-width: thin 0 thin 0;
                transform: scaleX(0);
            }
        }
    } 
}
.cellType {
    padding: 0 6px !important;   
    .v-text-field > .v-input__control > .v-input__slot:before, .v-text-field > .v-input__control > .v-input__slot:after {
        width: 0;
    }
}
.hdrType {
    width: 260px;
}
.checkBoxCell {
    .v-input--selection-controls {
        margin-top: 0;
    }
    .v-input__slot {
        display: flex;
        justify-content: center;
    }
}
.error--text {
    color: #ff5252 !important;
    caret-color: #ff5252 !important;
}
.white--text {
    color: white;
}
.txtName {
    .v-input__slot {
        min-height: 0px !important;
    }
}
// .elevation-1
</style>
